import { desktopOnly, mobileOnly } from './MediaQuery.css'

export function Desktop ({ children, className, ...props }: { children: React.ReactNode } & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props} className={className ? `${desktopOnly} ${className}` : desktopOnly}>
      {children}
    </div>
  )
}

export function Mobile ({ children, className, ...props }: { children: React.ReactNode } & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props} className={className ? `${mobileOnly} ${className}` : mobileOnly}>
      {children}
    </div>
  )
}
